import {
	createAPI
} from './http'
import axios from "axios";
import {
	API_SVC_HOST
} from '../config/common';
axios.create({
	baseURL: API_SVC_HOST
});

const api = createAPI();

/* 登录 */
export function login(params) {
	return api.post('/api/login', params)
}

/**
 * mmt/ftt数据
 */
export function getReport(params) {
	return api.get(`/api/report/${params.type}/${params.id}`, params)
}

/* 上传文件 */
export function uploadFile(file) {
	const formData = new FormData()
	formData.append('file', file)
	return api.upload('/api/upload', formData, {
		'Content-Type': 'multipart/form-data'
	},
	)

}

/**
 * 角色列表
 */
export function getRole(params) {
	return api.get('/api/role', params)
}

/**
 * 所有角色（用户列表页筛选角色使用、创建用户页面使用）
 */
export function getRoleSelect() {
	return api.get('/api/role_select')
}



/**
 * 用户列表
 */
export function getUser(params) {
	return api.get('/api/user', params)
}

/**
 * 新建用户
 */
export function createUser(params) {
	return api.post('/api/user', params)
}

/**
 * 删除用户
 */
export function deleteUser(id) {
	return api.delete(`/api/user/detail/${id}`)
}

/**
 * 修改用户
 */
export function editUser(params) {
	return api.put(`/api/user/detail/${params.id}`, params)
}

/**
 * 用户详情
 */
export function userDetail(id) {
	return api.get(`/api/user/detail/${id}`)
}

/**
 * HScode 管理接口
 */

export function getHscode(params) {
	//tree list
	return api.get('/api/hscode_management', params)
}

export function getHscodeDataBase() {
	//tree list
	return api.get('/api/hscode_management_database')
}

export function getHscodeDetail(id, params) {
	return api.get('/api/hscode_management/' + id, params)
}

export function getHscoderelationship() {
	//hscode 关系 包含node links 展示关系图
	return api.get('/api/hscode/')
}

export function postHscode(params) {
	return api.post('/api/hscode_management', params)
}

export function putHscode(id, params) {
	return api.put('/api/hscode_management/' + id, params)
}

export function deleteHscode(id) {
	return api.delete('/api/hscode_management/' + id)
}

export function getHscode_management_index_category() {
	//hscode 分类
	return api.get('/api/hscode_management_index_category')
}

export function copyHscode(id){
	// 复制shcode
	return api.post('/api/hscode_management_copy', {id: id})
}

export function get_index_standard_calculation_mode() {
	//hscode 计算方式
	return api.get('/api/public/index_standard_calculation_mode')
}

export function postHscode_management_index(data) {
	//hscode 顶层排序
	return api.post('/api/hscode_management_index', data)
}

/**
 * 服装 管理接口
 */

export function postGarment_v3(params) {
	return api.post('/api/garment_v3', params)
}
export function putGarment_v3(id, params) {
	return api.put('/api/garment_v3/' + id, params)
}

export function getGarmentDetail_v3(id) {
	return api.get('/api/garment_v3/' + id)
}

export function getGarment_v3() {
	return api.get('/api/garment_v3')
}

export function deleteGarment_v3(id) {
	return api.delete('/api/garment_v3/' + id)
}

/**
 * 产品模板管理接口
 */

export function postProductTemplate(params) {
	return api.post('/api/database_template_v3', params)
}
export function putProductTemplate(id, params) {
	return api.put('/api/database_template_v3/' + id, params)
}

export function putProductTemplateStatus(id, params) {
	return api.put('/api/database_template_status_v3/' + id, params)
}

export function getProductTemplate(id) {
	return api.get('/api/database_template_v3/' + id)
}


export function getProductTemplateList(params) {
	return api.get('/api/database_template_v3', params)
}

export function deleteProductTemplate(id) {
	return api.delete('/api/database_template_v3/' + id)
}

export function getProductTemplateInfo() {
	return api.get('/api/database_template_default_data_v3')
}

export function getProductTemplatePt() {
	return api.get('/api/database_template_public_type_v3')
}

export function getProductTemplateMenu() {
	return api.get('/api/database_template_menu_v3')
}

export function getDatasBaseListV3() {
	return api.get('/api/database_template_list_v3')
}

export function copyProductTemplate(params) {
	return api.post('/api/database_template_copy_v3', params)
}

export function database_template_name_v3(params) {
	return api.get('/api/database_template_name_v3', params)
}

export function database_default_data_v3(params) {
	return api.get('/api/database_default_data_v3', params)
}

/**
 * 产品部分接口
 */
//产品列表
export function getProductsList(params) {
	return api.get('/api/database_list', params)
}

export function getProductsListV3(params) {
	return api.get('/api/database_v3', params)
}

export function copyProduct(params) {
	return api.post('/api/database_list_copy', params)
}

// export function deleteProduct(table_name, id) {
export function deleteProduct(id) {
	return api.delete(`/api/database_list/${id}`)
	// return api.delete(`/api/database_v3/${table_name}/${id}`)
}

export function postProduct(params) {
	return api.post('/api/database_list', params)
	// return api.post('/api/database_v3', params)
}
export function putProduct(id, params) {
	// export function putProduct(table_name, id, params) {
	return api.put(`/api/database_list/${id}`, params)
	// return api.put(`/api/database_v3/${table_name}/${id}`, params)
}

// export function getProductDetail(table_name, id) {
export function getProductDetail(id, params) {
	return api.get(`/api/database_v3/${id}`, params)
	// return api.get(`/api/database_v3/${table_name}/${id}`)
}

export function getProductDetailV3(id, params) {
	return api.get(`/api/database_list/${id}`, params)
	// return api.get(`/api/database_v3/${table_name}/${id}`)
}

export function getDataBaseIndexStandard(params) {
	return api.get(`/api/database_index_standard_v3`, params)
}

export function getFileUrl(params) {
	return api.get(`/api/attachments`, params)
}
// 桑基图
export function sankey_v3(params) {
	return api.post(`/api/sankey_v3`, params)
}

export function database_hscode_v3(params) {
	return api.get(`/api/database_hscode_v3`, params)
}

export function database_structure(params) {
	// 产品组成结构查询列表
	return api.get('/api/database_structure', params)
}


/**
 * 登录注册部分
 */
export function login_v3(params) {
	return api.post('/api/login_v3', params)
}

export function register_v3(params) {
	return api.post('/api/register_v3', params)
}
export function reset_password(params) {
	return api.post('/api/reset_password', params)
}
export function sendMail(params) {
	// 发送邮件
	return api.post('/api/email_v3', params)
}
export function email_verify_v3(params) {
	// 发送邮件
	return api.post('/api/email_verify_v3', params)
}


export function getUserDetail(id) {
	// 获取当前用户信息
	return api.get(`/api/user_v3/${id}`)
}

export function perfect_information(id, params) {
	// 完善资料信息
	return api.put(`/api/perfect_information_v3/${id}`, params)
}

export function perfect_information_user_v3(params) {
	// 游客查询完善资料信息
	return api.get(`/api/perfect_information_user_v3`, params)
}

export function company_type_list() {
	// 游客查询完善资料信息
	return api.get(`/api/public/company_type`,)
}



export function update_username(params) {
	// 完善资料信息
	return api.post(`/api/update_username`, params)
}

export function update_userInfo(id, params) {
	// 管理页修改资料信息
	return api.put(`/api/user_v3/${id}`, params)
}

export function update_userInfo_by_user(id, params) {
	// 普通用户修改资料信息
	return api.put(`/api/user_edit_v3/${id}`, params)
}

export function getOrganizationList() {
	// 获取组织机构列表
	return api.get(`/api/organization`)
}

/**
 * 商业用户管理
 * 
 */
export function getBusinessInfoList(params) {
	return api.get('/api/user_v3', params)
}

export function deleteBusinessInfo(id) {
	return api.delete(`/api/user_v3/${id}`)
}

export function getBusinessInfoDetail(id) {
	return api.get(`/api/user_v3/${id}`)
}

export function putBusinessInfoStatus(id, params) {
	return api.put(`/api/user_status_v3/${id}`, params)
}

export function user_company_address_v3(params) {
	return api.get(`/api/user_company_address_v3`, params)
}

export function user_review_v3(id, params) {
	/**审核 */
	return api.put(`/api/user_review_v3/${id}`, params)
}

export function permission_tree_v3() {
	/**权限tree */
	return api.get(`/api/permission_tree_v3`)
}
export function set_permission_user_v3(params) {
	/**设置权限 */
	return api.post(`/api/permission_user_v3`, params)
}
export function get_permission_user_v3(params) {
	/**查询权限 */
	return api.get(`/api/permission_user_v3`, params)
}


export function get_user_index_standard(params) {
	/**删除子用户 */
	return api.get(`/api/user_index_standard`, params)
}

export function post_user_index_standard(params) {
	/**删除子用户 */
	return api.post(`/api/user_index_standard`, params)
}